export interface ApiOptions {
  method?: string;
  body?: unknown;
  headers?: Record<string, string>;
  signal?: AbortSignal;
}

// Chyba s HTTP stavom, aby volajúci vedel odlíšiť SKUTOČNÚ chybu od informačného stavu.
// 409 (Conflict) používame na hlášky typu „Pozvánka už čaká na potvrdenie." — tie sa v UI
// nesmú ukazovať červené (pozri `st.infoNote` vs `st.err`).
export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

export async function api<T = unknown>(path: string, opts: ApiOptions = {}): Promise<T> {
  const res = await fetch(path, {
    method: opts.method,
    headers: { "Content-Type": "application/json", ...opts.headers },
    body: opts.body ? JSON.stringify(opts.body) : undefined,
    signal: opts.signal,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError((data as { error?: string }).error || "Chyba", res.status);
  return data as T;
}

// Persist a new manual order for one task kind ('habit' | 'onetime').
export async function saveOrder(kind: string, ids: number[]): Promise<void> {
  await api("/api/tasks/reorder", { method: "POST", body: { kind, order: ids } });
}

// Navigate to a user's public profile (works logged-out; supports deep links).
export const openProfile = (uid: number): void => { window.location.href = "/u/" + uid; };
